import i18n from "@i18n"
import * as validators from '@vuelidate/validators'

const { createI18nMessage } = validators

const messagePath = ({ $validator }) => `validations.${$validator}`

const messageParams = (params) => ({
    ...params,
    property: i18n.global.t(`fields.${params.property}`),
})

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n), messagePath, messageParams })

// validators list
export const required = withI18nMessage(validators.required)
export const minLength = withI18nMessage(validators.minLength, { withArguments: true })
export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true })
export const minValue = withI18nMessage(validators.minValue, { withArguments: true })
export const maxValue = withI18nMessage(validators.maxValue, { withArguments: true })
